module.exports = __webpack_public_path__ + "static/media/ic_wonder_moment.8a7e0058.png";